module.exports = __webpack_public_path__ + "img/ltktrendingcreators-1x.46308cb.jpg";